import type { z } from 'zod';

import { GhostTextDataV2Schema } from './ghost-text-data-v2-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { GhostTextDataV2Schema } from './ghost-text-data-v2-schema';

/**
 * Ghost text experiment cohort enum
 */
export enum GhostTextExperimentCohort {
	CONTROL = 'control',
	THREE_P = '3p',
}

/**
 * Number of times to show each text before rotating to the next
 */
export const ROTATION_THRESHOLD = 3;

export type GhostTextDataV2 = z.infer<typeof GhostTextDataV2Schema>;

export type GhostTextRotation = Pick<GhostTextDataV2, 'id' | 'text'>;

/**
 * Parse ghost text data from a JSON string.
 * Validates the data against GhostTextDataV2Schema.
 *
 * @param customPlaceholder - JSON string containing ghost text data
 * @returns Parsed GhostTextDataV2 or undefined if invalid/empty
 */
export const parseGhostTextData: (
	customPlaceholder: string | undefined,
) => GhostTextDataV2 | undefined = (
	customPlaceholder: string | undefined,
): GhostTextDataV2 | undefined => {
	if (!customPlaceholder) {
		return undefined;
	}

	try {
		const result = GhostTextDataV2Schema.safeParse(JSON.parse(customPlaceholder));
		if (result.success) {
			return result.data;
		}
		return undefined;
	} catch {
		return undefined;
	}
};
